import { createFeatureSelector, createSelector } from '@ngrx/store';

import { UiState } from './ui.model';
import { inRoomUiFeatureKey } from './ui.reducer';

export const selectUiState = createFeatureSelector<UiState>(inRoomUiFeatureKey);

export const isTerminalOpen = createSelector(selectUiState, (state: UiState) => state.isTerminalOpen);
